import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bms-history"
}
const _hoisted_2 = { class: "col-3 text-center" }
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "bms-history-status" }
const _hoisted_7 = { class: "col-9" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "history-notification-text" }
const _hoisted_10 = {
  key: 1,
  class: "bms-history"
}

import { MessageHistory, messageActionMappedToGerman } from '@/models/message.model';
import { onMounted, ref } from 'vue';
import messageRepository from '@/api/messageRepository';
import useDateFormats from '@/composables/general/useConverter';
import Skeleton from 'primevue/skeleton';


export default /*#__PURE__*/_defineComponent({
  props: {
  messageid: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props


const { localeDateStringLong } = useDateFormats();
const loading = ref(false);
const messageHistory = ref<MessageHistory[] | null>();

onMounted(() => {
  loading.value = true;
  messageRepository
    .getMessageHistoryEntries({
      messageid: props.messageid,
      statuschange: 1,
    })
    .then(response => {
      messageHistory.value = response;
    })
    .finally(() => {
      loading.value = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value && messageHistory.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageHistory.value, (history) => {
            return (_openBlock(), _createElementBlock("div", {
              key: history.id,
              class: "row p-4 pr-1"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (history.icon_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "mt-1",
                        src: history.icon_url
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(messageActionMappedToGerman)[history.action]), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", null, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(history.owner ? history.owner.public_name : 'Unbekannter Teilnehmer'), 1),
                  _createElementVNode("small", null, "  am " + _toDisplayString(_unref(localeDateStringLong)(history.created)), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("i", _hoisted_9, _toDisplayString(history.text), 1),
                  _createTextVNode(" " + _toDisplayString(history.manual_text), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(Skeleton), {
            height: "120px",
            class: "mb-3"
          }),
          _createVNode(_unref(Skeleton), {
            height: "120px",
            class: "mb-3"
          }),
          _createVNode(_unref(Skeleton), {
            height: "120px",
            class: "mb-3"
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})